export const RAPID_DIFFS_COOKIE_NAME = 'rapid_diffs_enabled';
